<template>
          <Card>
              <p slot="title">
                  Kontra Print Status
              </p>
            <Row type="flex" justify="space-between" class="code-row-bg">
                <Col span="4">
                    <Date-picker v-model="searchCreatedDate"
                        type="date"
                        placeholder="Tgl.Buat"
                        format="dd/MM/yyyy">
                    </Date-picker>
                </Col>

                <Col span="4">
                    <Select v-model="searchSelectDepartement"
                        clearable
                        placeholder="Dept. Item"
                        >
                        <Option v-for="dept, idx in departements" :value="dept.id" :key="idx">
                            {{ dept.deptName }}
                        </Option>
                    </Select>
                </Col>

                <Col span="2">
                    <Select
                        v-if="searchSelectSubbranch == 'JKT'"
                        v-model="searchSelectSubbranch"
                        clearable
                        placeholder="Branchcode"
                        @on-change="setMarkingCode"
                        >
                        <Option v-for="subbranch, idx in subbranchs" :value="subbranch.subbranchcode" :key="idx">
                            {{ subbranch.subbranchname }}
                        </Option>
                    </Select>
                    <Select
                        v-else
                        v-model="searchSelectSubbranch"
                        placeholder="Branchcode"
                        @on-change="setMarkingCode"
                        >
                        <Option v-for="subbranch, idx in subbranchs" :value="subbranch.subbranchcode" :key="idx">
                            {{ subbranch.subbranchname }}
                        </Option>
                    </Select>

                </Col>

                <Col span="4">
                    <Select
                        placeholder="Ketik Marking"
                        v-model="searchMarkingId"
                        filterable
                        clearable
                        remote
                        :remote-method="getMarkingByCode"
                        :loading="loadingGetMarking"
                        >
                        <Option v-for="option in searchOptionMarkings"
                            :value="option.value" :key="new Date()">{{option.label}}</Option>
                    </Select>
                </Col>
                <Col span="4">
                    Filter <Input-number :max="500" :min="1" v-model="filterResult"></Input-number>
                </Col>
                <Col span="4">
                    <Button type="primary"
                        :loading="loadingGetReadyPrint"
                        icon="ios-search-strong"
                        @click="getReadyPrint">
                        <span v-if="!loadingGetReadyPrint">Cari</span>
                        <span v-else>Wait.</span>
                    </Button>
                </Col>
            </Row>
            <br>
            <Alert
              v-show="kontras.length > 0"
              type="success">Showing {{kontrasToShow.length}} from {{kontras.length}} Marking - Printer Location : {{printerServerIP}}</Alert>
            <br>
            <Table
                v-show="kontras.length > 0"
                :columns="tableColumn"
                :data="kontrasToShow"
                no-data-text=""></Table>
          </Card>
</template>
<script>
import {HTTP} from '@/components/http-lib'
import {SPARK} from '@/components/http-lib'

import _ from 'lodash'
import moment from 'moment'
const numeral = require('numeral');


    export default {
        data () {
            return {
            kontras : [],
            filterResult : 50,
            invoiceDate : '',
            departementId : '',
            departements : '',
            subbranchs: '',
            searchCreatedDate : '',
            searchSelectDepartement : '',
            searchSelectSubbranch : localStorage.getItem('user.subbranchcode'),
            searchMarkingId : '',
            searchOptionMarkings : '',
            loadingGetMarking : false,
            loadingGetReadyPrint : false,
            markingIdSelected : '',
            kontrasToShow : [],
            printerServerIP : localStorage.getItem('serverIP'),
            printer : {
                printername : localStorage.getItem('printerName'),
                printerIP : localStorage.getItem('printerIP')
            },
            tableColumn: [
                    {
                        type: 'index',
                        width: 60,
                        align: 'center'
                    },
                    {
                        title: 'markingcode',
                        key: 'markingcode',
                        sortable: true
                    },
                    {
                        title: 'create',
                        key: 'kontraCreatedAt',
                        sortable: false
                    },
                    {
                        type: 'html',
                        title: 'description',
                        key: 'description',
                        sortable: false
                    },
                    {
                        type: 'html',
                        title: 'Dept',
                        key: 'deptNames',
                        sortable: false
                    },

                    {
                        type: 'html',
                        title: 'loaddate',
                        key: 'loaddates',
                        sortable: false
                    },
                    {
                        type: 'html',
                        title: 'Total',
                        key: 'invoiceFees',
                        align: 'right',
                        sortable: false
                    },
                    {
                        title: 'Action',
                        key: 'printed',
                        width: 150,
                        align: 'center',
                        render: (h, params) => {
                            const row = params.row;
                            let classButton = row.printed == true ? 'ivu-btn-success' : 'ivu-btn-primary';
                            const text = row.printed == true ? '' : 'Selesai';
                            const isSuccessPrinted = row.isSuccessPrinted;

                            if (!isSuccessPrinted) {
                                classButton = 'ivu-btn-error'
                            }
                            if(row.canPrint){
                                return h('div', [
                                    h('Button', {
                                        style: {
                                            marginRight: '5px'
                                        },
                                        class: "ivu-btn ivu-btn-small " + classButton,
                                        on: {
                                            click: () => {
                                                // jika belum print
                                                if(row.printed == false){
                                                    this.doPrinting(params.index)
                                                }
                                            }
                                        }
                                    }, text)
                                ]);
                            }

                        }
                    }
                ]
            }
        },
        methods: {
            show (index) {
                console.log(this.kontras[index])
            },
            remove (index) {
                this.data6.splice(index, 1);
            },
            getReadyPrint: function(){
                this.loadingGetReadyPrint = true

                if(this.searchCreatedDate != ''){
                    this.searchCreatedDate = moment(this.searchCreatedDate).format('YYYY/MM/DD')
                }

              HTTP
                .post('kontra/readyPrint', {
                    createdDate: this.searchCreatedDate ,
                    departementId: this.searchSelectDepartement || null,
                    markingHeaderId: this.searchMarkingId,
                    subbranchcode: this.searchSelectSubbranch || null
                })
                .then(response => {

                  var formattedKontras = [];
                  _.forEach(response.data, function(value) {

                    if(value.kontras[0] != null)
                    {
                        let kontraid = value.kontras[0].kontraid;
                        let detailMarking  = value.kontras[0].invoices[0];
                        let markingcode = value.markingheadercode;

                        let markinginfoaddress1 = detailMarking.markinginfoaddress1;
                        let markinginfoaddress2 = detailMarking.markinginfoaddress2;
                        let markinginfophone1 = detailMarking.markinginfophone1;
                        let markinginfophone2 = detailMarking.markinginfophone2;
                        let markinginfoname = detailMarking.markinginfoname;
                        let canPrint = true;


                        _.forEach(value.kontras, function(kontra) {

                            let kontraCreatedAt =
                            moment(kontra.created_at).format('YYYY-MM-DD');

                            let invoiceFees = '';
                            let loaddates = '';
                            let deptNames= '';

                            let description = '';

                            let invoices = kontra.invoices;

                            _.forEach(invoices, function(invoice) {

                                 if(invoice.detail == null){
                                    console.log(markingcode)
                                    console.log(invoice)
                                    canPrint = false;
                                } else {
                                    // console.log(invoice.invoiceid);
                                    let containercode = invoice.detail.container.containercode;
                                    let deptName = '';

                                    if(invoice.deptName){
                                        deptName = invoice.deptName + '<br/>';
                                    } else {
                                        deptName = 'None' + '<br/>';
                                    }


                                    let loaddate = moment(invoice.detail.container.loaddate).format('DD-MM-YYYY')+ '<br/>';

                                    let subDescription = 'P. '+containercode +' <br/>';
                                    description += subDescription;

                                    let invoiceFee = numeral(invoice.invoicefee).format('0,0')+ '<br/>';

                                    invoiceFees +=invoiceFee;
                                    loaddates += loaddate;
                                    deptNames += deptName;
                                }
                            });



                            let kontraData = {
                                kontraid : kontraid,
                                kontraCreatedAt : kontraCreatedAt,
                                markingcode : markingcode,
                                markinginfoaddress1 : markinginfoaddress1,
                                markinginfoaddress2 : markinginfoaddress2,
                                markinginfophone1 : markinginfophone1,
                                markinginfophone2 : markinginfophone2,
                                markinginfoname : markinginfoname,
                                invoices : invoices,
                                loaddates : loaddates,
                                deptNames : deptNames,
								invoiceFees : invoiceFees,
                                description : description,
                                printed : false,
                                isSuccessPrinted : true,
                                printer : localStorage.getItem('printerName'),
                                serverAPI : localStorage.getItem('serverIP'),
                                canPrint : canPrint
                            }

                            formattedKontras = _.sortBy(formattedKontras, ['markingcode']);
                            formattedKontras.push(kontraData);

                        });
                    }


                  });

                  this.kontras = formattedKontras;
                    formattedKontras = _.sortBy(formattedKontras, ['markingcode']);
                    formattedKontras = _.chunk(formattedKontras, this.filterResult);
                    let formattedKontrasFirstArray = formattedKontras[0]

                    if(formattedKontrasFirstArray != null){
                        if(formattedKontrasFirstArray.length > 0){
                            this.kontrasToShow = formattedKontras[0];
                        }
                    }

                    this.loadingGetReadyPrint = false
                })
                .catch(e => {
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
            },
            doPrinting: async function(index)
            {
                this.kontrasToShow[index].printed = true;
                let textToPrint = this.kontrasToShow[index];

                let kontraRow = index;

                let textToPrintFormatted = {
                    markingcode : textToPrint.markingcode,
                    kontraRow : kontraRow
                }

                console.log(textToPrint)

                let kontraId = textToPrint.kontraid;
                this.setIsPrint(textToPrint, kontraId, index);

            },
            setIsPrint: function(textToPrint, kontraId, index) {
               this.handleSetPrintKontra(kontraId);
            },
            handleSetPrintKontra: function(kontraId) {
            const kontras = [
                {
                    id : kontraId
                }
            ];
            HTTP
                .post('kontra/print', {
                    kontras
                })
                .then(() => {
                    console.log("Update Status Success !")
                })
                .catch(err => {
                    this.$Notice.error({
                        type: "negative",
                        message: err.response.data.errors,
                        position: "top"
                    });
                });
            },
            getDepartement: function(){
                HTTP
                .get('itemDept')
                .then(response => {
                    this.departements = response.data
                })
                .catch(e => {
                    //console.log(e);
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
            },
            getSubbranch: function(){
                HTTP
                .get('subbranch')
                .then(response => {
                    this.subbranchs = response.data
                })
                .catch(e => {
                    //console.log(e);
                    this.$Notice.error({
                        title: "Error",
                        desc: e,
                        duration: 5
                    });
                })
            },
            setMarkingCode: function(){
                this.searchMarkingId = ''
            },
            getMarkingByCode: _.debounce(
                function (query) {
                    if (query !== '') {
                        this.loadingGetMarking = true;

                        HTTP
                        .post('marking/getBySnapshot', {
                            markingHeaderId: query,
                            subbranchcode: this.searchSelectSubbranch || null
                        })
                        .then(response => {
                            this.loadingGetMarking = false;
                            let data = response.data;

                            const list = data.map(item => {
                                return {
                                    value: item.markingheaderid,
                                    label: item.markingheadercode
                                };
                            });

                            this.searchOptionMarkings = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);
                            console.log(this.searchOptionMarkings[0]);
                        })
                        .catch(e => {
                            this.$Notice.error({
                                title: "Error",
                                desc: e,
                                duration: 5
                            });
                        })
                    } else {
                        this.searchOptionMarkings = [];
                    }
                }, 400
            ),
            showError (title, detail) {
                this.$Notice.error({
                    title: title,
                    desc: detail,
                    duration: 0
                });
            }
        },
        created() {
            console.log('start..........')
            this.getDepartement();
            this.getSubbranch();
        }
    }
</script>



// WEBPACK FOOTER //
// KontraIsPrint.vue?6a742e0f